import { useEffect, useState } from 'react';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { ORIGIN_ID } from '../../../constants';
import { FRAUDSTER_TOOL_KYC } from '../../../constants/fraud';
import { MODAL_TYPE_KYC } from '../../../services/modal/constants';
import { KYC_STATE_VALIDATED } from '../../../services/kyc/constants';

import { showModal } from '../../../services/modal/actions';
import { createOrder } from '../../../services/ebon/actions';

import { getClickId, getSource, getUserId } from '../../../utils/plebicardUtils';

const FunnelFraudVerificationStep = ({
    partnerId,
    userInfo,
    ebon,
    createOrder,
    showModal,
    lock,
    kycState
}) => {
    const [kycValidated, setKycValidated] = useState(false);

    const userId = getUserId();
    const clickId = getClickId();
    const source = getSource();

    const hasFreeFacial = ebon.ebons.freeFacialValue !== undefined;

    // Handle lock response
    useEffect(() => {
        if (!isEmpty(lock)) {
            // Get fraudster tools
            const fraudsterProbability =
                lock[0].fraudsterProbability && lock[0].fraudsterProbability.suspected === true;
            const fraudsterByPassing =
                lock[0].fraudsterProbability &&
                lock[0].fraudsterProbability.bypassing &&
                lock[0].fraudsterProbability.bypassing.includes('CHECKOUT');
            const fraudsterTools = fraudsterProbability && lock[0].fraudsterProbability.tools;

            // Use appropriate fraudster tool
            if (
                fraudsterProbability &&
                !fraudsterByPassing &&
                fraudsterTools.includes(FRAUDSTER_TOOL_KYC)
            ) {
                showModal(MODAL_TYPE_KYC, {
                    hideCloseButton: true,
                    useCase: null
                });
            } else {
                handleCreateOrder();
            }
        }
    }, [lock]);

    // Create order
    const handleCreateOrder = () => {
        createOrder(
            userInfo.email,
            userInfo.phoneNumber,
            !hasFreeFacial,
            partnerId,
            userId,
            clickId,
            ORIGIN_ID,
            source
        );
    };

    /* Start KYC verification */
    useEffect(() => {
        if (kycState === KYC_STATE_VALIDATED) {
            setKycValidated(true);
        }
    }, [kycState]);

    useEffect(() => {
        if (kycValidated) {
            handleCreateOrder();
        }
    }, [kycValidated]);
    /* End KYC verification */

    return null;
};

FunnelFraudVerificationStep.propTypes = {
    partnerId: PropTypes.number,
    userInfo: PropTypes.object
};

const mapStateToProps = (state, ownProps) => {
    return {
        ebon: state.ebon,
        form: state.form,
        lock: state.ebon.lock,
        kycState: state.kyc.state
    };
};

const mapDispatchToProps = {
    createOrder,
    showModal
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(FunnelFraudVerificationStep)
);



// WEBPACK FOOTER //
// ./src/components/funnel/fraud-verification-step/FunnelFraudVerificationStep.js